import SomApi from './lib/speedofme'
import React from 'react'

import * as check from './check'
import CheckRow from './check-row'


SomApi.account = 'SOM58271a1e7f8f2'
SomApi.domainName = 'localhost'

export default class SpeedOfMe extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      testInProgress: true,
      testFailed: false
    }
  }

  componentDidMount() {
    SomApi.onTestCompleted = result => this.onTestCompleted(result)
    SomApi.onError = error => this.onError(error)
    SomApi.onProgress = progress => this.onProgress(progress)

    SomApi.config = {
      sustainTime: 4,
      testServerEnabled: true,
      userInfoEnabled: false,
      latencyTestEnabled: true,
      uploadTestEnabled: true,
      progress: {
        enabled: false,
        verbose: false
      }
    }
    console.log('Speed test in progress. Please wait...')
    SomApi.startTest()
  }

  onError (error) {
    const {code, message} = error

    this.setState({
      testInProgress: false,
      testFailed: true,
      message: `${code} ${message}`
    })
  }

  onTestCompleted (testResult) {
    this.setState({
      testInProgress: false,
      testFailed: false,
      results: testResult
    })
  }

  render () {
    const {testInProgress, testFailed} = this.state
    const connectionSpeedTh = (
      <thead>
        <tr>
          <th colSpan={3}>Connection Speed Tests</th>
        </tr>
      </thead>)

    if (testInProgress) {
      return (
        <table>
          {connectionSpeedTh}
          <tbody>
            <tr>
              <td colSpan={3}>In progress...</td>
            </tr>
          </tbody>
        </table>
      )
    }
    else if (testFailed) {
      return (
        <table>
          {connectionSpeedTh}
          <tbody>
            <tr>
              <check.Check status={'error'} />
              <td colSpan={2}>Error: {this.state.message}</td>
            </tr>
          </tbody>
        </table>)
    }
    // Test succeeded, evaluate results
    const {
      latency,
      jitter,
      download,
      upload
    } = this.state.results

    return (
      <table>
        {connectionSpeedTh}
        <tbody>
          <CheckRow name={'Download'}
                    checkFeature={check.downloadSpeed(download)} />
          <CheckRow name={'Upload'}
                    checkFeature={check.uploadSpeed(upload)} />
          <CheckRow name={'Latency'}
                    checkFeature={check.latency(latency)} />
          <CheckRow name={'Jitter'}
                    checkFeature={check.jitter(jitter)} />
        </tbody>
      </table>
    )
  }
}



function onProgress(progress) {
  console.log(progress)
}



// WEBPACK FOOTER //
// ./app/speedofme-wrapper.js